import React from 'react'
import ReactDOM from 'react-dom'
import { Provider } from 'react-redux'
import { ThemeProvider } from 'styled-components'
import reportWebVitals from './reportWebVitals'
import theme from './theme.js'
import App from './App'
import SimpleReactLightbox from 'simple-react-lightbox'
import Loading from './components/Loading'
import reducers from './reducers'
import { webConfigApi } from './services/webConfigApi'
import { setupListeners } from '@reduxjs/toolkit/dist/query'
import { configureStore } from '@reduxjs/toolkit'

// redux
// const INITIAL_STATE = {
//   user: null,
// };

// const reducer = (state = INITIAL_STATE, { type, data }) => {
//   switch (type) {
//     case "UPDATE_USER":
//       return { ...state, userLoaded: true, user: data };
//     default:
//       return state;
//   }
// };

const store = configureStore({
  reducer: reducers,
  middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(webConfigApi.middleware),
})
setupListeners(store.dispatch)
// set Store Reducer
ReactDOM.render(
  <ThemeProvider theme={theme}>
    <SimpleReactLightbox>
      <Provider store={store}>
        {/* <BrowserRouter> */}
        {/* <Router> */}
        <Loading />
        <App />
        {/* </Router> */}
        {/*   </BrowserRouter> */}
        {/* <Router>
          <Route exact path="/login" component={Login} />
          <Route path="/" component={App} />
        </Router> */}
      </Provider>
    </SimpleReactLightbox>
  </ThemeProvider>,
  document.getElementById('root'),
)

// reportWebVitals();
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
if ('serviceWorker' in navigator) {
  navigator.serviceWorker
    .register('../firebase-messaging-sw.js')
    .then(function (registration) {
      console.log('Registration successful, scope is:', registration.scope)
    })
    .catch(function (err) {
      console.log('Service worker registration failed, error:', err)
    })
}
